import { useEffect } from 'react'
import useMetrics from '../hooks/useMetrics'
import MetricsCard from '../components/MetricsCard'
import { Box } from '@mui/material'

const OrdersMetrics = () => {
  const { metrics, fetchMetrics } = useMetrics()

  useEffect(() => {
    fetchMetrics()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!metrics) return <></>

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr 1fr',
        gap: 2,
        mb: 2
      }}
    >
      <MetricsCard
        labelLeft="Open Orders"
        labelRight="Open Items"
        valueLeft={metrics.openOrders}
        valueRight={metrics.openItems}
      />
      <MetricsCard
        labelLeft="Shipped Orders"
        labelRight="Shipped Items"
        valueLeft={metrics.shippedOrders}
        valueRight={metrics.shippedItems}
      />
      <MetricsCard
        labelLeft="Late Orders"
        labelRight="Late Items"
        valueLeft={metrics.lateOrders}
        valueRight={metrics.lateItems}
        textColor="red"
      />
      <MetricsCard
        labelLeft="Total Late Orders"
        labelRight="Total Late Items"
        valueLeft={metrics.totalLateOrders}
        valueRight={metrics.totalLateItems}
        textColor="red"
      />
    </Box>
  )
}

export default OrdersMetrics
